export default __webpack_public_path__ + "fonts/lead-auto-sm-img.svg";